import { formatPercentage } from "@lib/formatters";

export function formatAsPercentage(x: number): string {
  return formatPercentage(x);
}

export { formatPercentage };
